import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Editor from "@component/UI/TMEditor";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const { site, iam } = useContext(AppContext);
    const [list, setList] = useState([]);
    const [resultView, setResultView] = useState(null);
    const [select, setSelect] = useState([]);
    const [sendEmail, setSendEmail] = useState(null);
    const [cfg, setCfg] = useState(null);

    const loadConfig = () => {
        _API.get({ path: "/site/abstract/config" })
            .then((res) => {
                const { cfg } = res.data;
                setCfg(cfg);
                console.log(cfg);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    const loadData = () => {
        _API.get({ path: "/site/mypage" })
            .then((res) => {
                const { abstract } = res.data;
                setList(abstract);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    useEffect(() => {
        if (site?.siteCode) {
            loadConfig();
            loadData();
        }
    }, [site?.siteCode]);

    const getPresenting = (item) => {
        if (item && item?.authorInformation?.length > 0) {
            const present = item?.authorInformation?.find((a) => a.present === "Y");
            return (
                <>
                    {present.nameFirst} {present.nameLast}
                    <br />
                    {present.email}
                </>
            );
        }
        return "";
    };

    const onWithdrwal = (item) => {
        swal({
            title: "Are you sure you will withdraw the abstract? All the abstract data will be deleted if you click “OK”",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((result) => {
            if (result) {
                _API.post({
                    path: "/site/abstract/withdraw",
                    data: { ...item },
                })
                    .then((res) => loadData())
                    .catch((e) => _API.alert(e));
            }
        });
    };

    const onClickResult = (item) => {
        setResultView(item);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const onSelectClick = (e, item) => {
        let tmp = JSON.parse(JSON.stringify(select));

        if (e.target.checked) {
            tmp.push(e.target.value);
        } else {
            tmp = tmp.filter((s) => s != item.idx);
        }

        setSelect(tmp);
    };

    const isSelect = (item) => {
        return select.find((s) => s == item.idx);
    };

    const onAllSelect = (e) => {
        let result = [];

        if (e.target.checked) {
            for (let i in list) {
                result.push(list[i].idx);
            }
        } else {
            result = [];
        }

        setSelect(result);
    };

    const isAllSelect = () => {
        return list?.length === select?.length;
    };

    const onSendEmail = () => {
        if (select?.length === 0) {
            swal("Please select abstract to send email");
            return;
        }
        if (!sendEmail) {
            swal("Please enter an email to send");
            return;
        }

        _API.get({
            path: "/site/abstract/send",
            data: { select, sendEmail },
        }).then((res) => {
            swal("Mail sending complete");
        });
    };

    if (!_CK.isLogin()) {
        swal("Please Login first.").then(() => {
            document.location.href = "/";
        });

        return;
    }

    return (
        <Fragment>
            <div className="contents">
                {site?.naviMypageAbstract && parse(site?.naviMypageAbstract)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>Abstract Submission & Paper Status</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Abstract Submission & Paper Status</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <div className="boxTable">
                            <div className="sendAbstracts" style={{ textAlign: "right" }}>
                                Send abstracts to <input type="text" name="email" id="email" onChange={(e) => setSendEmail(e.target.value)} />
                                <button className="btnSmall2" onClick={onSendEmail}>
                                    SEND
                                </button>
                            </div>

                            <table className="tbl_mypage ">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            <input type="checkbox" name="chk_all" checked={isAllSelect()} onClick={onAllSelect} />
                                        </th>
                                        <th width="10%">Abs No.</th>
                                        <th>Abstract Title</th>

                                        <th width="15%">Presenting Author</th>
                                        <th width="15%">Submission Status</th>

                                        <th width="18%">
                                            Review Result /<br />
                                            Presentation Info.
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list?.length === 0 ? (
                                        <tr>
                                            <td colspan="8">No Data!!</td>
                                        </tr>
                                    ) : (
                                        <>
                                            {list?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input type="checkbox" value={item.idx} checked={isSelect(item)} onChange={(e) => onSelectClick(e, item)} />
                                                    </td>
                                                    <td>
                                                        <a href={`/mypage/abstract/${item.idx}`}>{item.abstractNo}</a>
                                                    </td>
                                                    <td>
                                                        <a href={`/mypage/abstract/${item.idx}`} dangerouslySetInnerHTML={{ __html: item?.title }}></a>
                                                    </td>

                                                    <td>{getPresenting(item)}</td>
                                                    <td>
                                                        <div>
                                                            <strong>{_DEF.getDefinedLabel(_DEF.ABSTRACT_STATUS, item.status)}</strong>
                                                            <br />(
                                                            {item.status === "N" ? (
                                                                <>{item.withdrawalDate ? moment(item.withdrawalDate).format("YYYY-MM-DD") : ""}</>
                                                            ) : (
                                                                <>{moment(item.regDate).format("YYYY-MM-DD")}</>
                                                            )}
                                                            )
                                                        </div>
                                                        {item.status !== "N" && (
                                                            <div>
                                                                <a href="" className="btn_inner1 mt5" onClick={() => navigate(`/mypage/abstract/${item.idx}`)}>
                                                                    Modify
                                                                </a>
                                                                <a href="" className="btn_inner1 mt5" onClick={() => onWithdrwal(item)}>
                                                                    Withdrwal
                                                                </a>
                                                            </div>
                                                        )}
                                                    </td>

                                                    <td>
                                                        {moment(cfg?.judgeDate) < moment() && item.status === "Y" && (item.finalStatus === "Y" || item.finalStatus === "R") ? (
                                                            <>
                                                                <strong>{_DEF.getDefinedLabel(_DEF.FINAL_STATUS, item.finalStatus)}</strong>
                                                                <br />
                                                                <a href="" className="btn_inner2 mt5" onClick={() => onClickResult(item)}>
                                                                    View
                                                                </a>
                                                            </>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="btnArea1 al_r">
                            <button className="btn4 btnBlue1" style={{ width: "auto" }} onClick={() => navigate("/abstract/regist")}>
                                NEW SUBMISSION
                            </button>
                        </div>

                        <div className="tablet_fix"></div>
                    </div>
                </div>
            </div>
            {resultView && <ResultView data={resultView} onClose={() => setResultView(null)} />}
        </Fragment>
    );
};

const ResultView = (props) => {
    const { data } = props;
    const [cfg, setCfg] = useState(null);

    const getPresenting = () => {
        if (data && data?.authorInformation?.length > 0) {
            const present = data?.authorInformation?.find((a) => a.present === "Y");
            return (
                <>
                    {present.nameFirst} {present.nameLast}
                    <br />
                    {present.email}
                </>
            );
        }
        return "";
    };

    const loadConfig = () => {
        _API.get({ path: "/site/abstract/config" })
            .then((res) => {
                const { cfg } = res.data;
                setCfg(cfg);
            })
            .catch((e) => {
                _API.alert({ message: e.message }).then(() => {
                    navigate("/");
                });
            });
    };

    useEffect(() => {
        if (data?.siteCode) {
            loadConfig();
        }
    }, [data?.siteCode]);

    return (
        <Fragment>
            <div className="popup" id="presentation_info" style={{ display: "block" }}>
                <div className="popup_inner">
                    <h4>Presentation Information</h4>
                    <div className="boxTable">
                        <table className="tbl_mypage ">
                            <tr>
                                <th width="20%">Abstract No.</th>
                                <td>{data?.abstractNo}</td>
                            </tr>
                            <tr>
                                <th>Abstract Title</th>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: data?.title,
                                    }}
                                ></td>
                            </tr>
                            <tr>
                                <th>Presenting Author </th>
                                <td>{getPresenting()}</td>
                            </tr>
                            <tr>
                                <th>Final PT Type </th>
                                <td>{_DEF.getDefinedLabel(_DEF.PRESENT_TYPE, data?.finalType)}</td>
                            </tr>
                            {cfg?.isUseTopic === "Y" && (
                                <tr>
                                    <th>Topic </th>
                                    <td>
                                        {cfg?.isUseTopicSecond === "Y" ? (
                                            <>
                                                <div>1st : {data?.topicFirst}</div>
                                                <div>2nd : {data?.topicSecond}</div>
                                            </>
                                        ) : (
                                            <>{data?.topicFirst}</>
                                        )}
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <th>Category1 </th>
                                <td>{data?.finalCategory1}</td>
                            </tr>
                            <tr>
                                <th>Category2 </th>
                                <td>{data?.finalCategory2}</td>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <td>{data?.finalTime}</td>
                            </tr>
                            <tr>
                                <th>Venue </th>
                                <td>{data?.finalRoom}</td>
                            </tr>
                            <tr>
                                <th>Session No. </th>
                                <td>{data?.finalAbstractNo}</td>
                            </tr>
                        </table>
                    </div>

                    <div className="btnArea1 center">
                        <a href="" className="btn1 btn_blue1" onClick={props.onClose}>
                            Close
                        </a>
                    </div>
                </div>
            </div>
            <div className="dim" style={{ display: "block" }}></div>
        </Fragment>
    );
};
